export default "/images/43e18922f17460810b1eb1a23059d883.avif";